export enum MltImageEditMessage {
  TITLE = 'Select Image',
  BUTTON_LABEL_SAVE = 'Select',
}
